import { useQuery } from "@tanstack/react-query";
import { useServices } from "@/services/ServiceProvider";
import { useAuthStore } from "@/stores/useAuthStore";

/**
 * Fetches all workspaces the current user is a member of.
 * Used by the sidebar to show workspace entries.
 */
export function useMyWorkspaces() {
  const { workspace } = useServices();
  const userId = useAuthStore((s) => s.session?.userId);

  return useQuery({
    queryKey: ["my-workspaces", userId],
    queryFn: () => workspace.getMyWorkspaces(userId!),
    enabled: !!userId,
    staleTime: 3_000,
    refetchInterval: 5_000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  });
}
